export default "__VITE_ASSET__vUUF8SEt__"